import React from 'react';
import Store from '../../_Store';

const Loading = ({ primary, secondary }) => {
    const { state: { utils: { loading } } } = React.useContext(Store);

    const Primary = primary || loading.primary;
    const Secondary = secondary || loading.secondary || 'Chargement en cours ...';

    return (
        <React.Fragment>
            <div id="Loading" className="flex justify-center items-center">
                <div className="text-center">
                    {Primary && (
                        <div className="font-bold mb-4">{Primary}</div>
                    )}
                    <div className="font-normal">{Secondary}</div>

                    <div className="lds-ring mt-8"><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
        </React.Fragment>
    );
}


export default Loading;